exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-header.bg-dark[data-v-06341eae]{background-color:#f6f7f7!important;color:#000!important;padding:5px 10px}.table td[data-v-06341eae]{padding:3px!important;padding-top:5px;border-bottom:1px solid #ddd;border-top:0 solid #ddd}@media screen and (max-width:768px){.card[data-v-06341eae]{margin-left:5px!important;width:185px!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-06341eae","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/filter/displayers/display-user-taskstatus.vue
// module id = 1661
// module chunks = 0